<template>
  <v-card flat>
    <v-container
      fluid
      class="pt-0 pb-0"
    >
      <v-row
        dense
        class="ml-1 mr-1"
      >
        <v-col
          cols="10"
          sm="11"
          md="6"
        >
          <v-row
            justify="center"
            align="center"
            style="height: 100%"
          >
            <v-text-field
              v-model="textSearch"
              color="orange"
              background-color="#5E5E5E"
              solo
              dark
              flat
              hide-details
              label="กด enter เพื่อค้นหา"
              prepend-inner-icon="fas fa-search"
              @keydown.enter="onSearch"
            />
          </v-row>
        </v-col>
        <v-col
          md="4"
          class="hidden-sm-and-down"
        >
          <v-row
            justify="center"
            align="center"
          >
            <v-btn-toggle
              v-model="currentStatus"
              dark
              group
              flat
              mandatory
              @change="onStatusChange"
            >
              <v-btn
                color="white"
                text
                value="All"
              >
                <div class="hidden-sm-and-down">
                  <span>{{ statusAllText }}</span>
                  <v-icon
                    right
                    small
                  >
                    {{ iconStatusAll }}
                  </v-icon>
                </div>
                <v-icon
                  small
                  class="hidden-md-and-up"
                >
                  {{ iconStatusAll }}
                </v-icon>
              </v-btn>
              <v-btn
                text
                color="white"
                value="ACTIVE"
              >
                <div class="hidden-sm-and-down">
                  <span>{{ statusActiveText }}</span>
                  <v-icon
                    right
                    small
                  >
                    {{ iconStatusActive }}
                  </v-icon>
                </div>
                <v-icon
                  small
                  class="hidden-md-and-up"
                >
                  {{ iconStatusActive }}
                </v-icon>
              </v-btn>
              <v-btn
                text
                color="white"
                value="INACTIVE"
              >
                <div class="hidden-sm-and-down">
                  <span>{{ statusInActiveText }}</span>
                  <v-icon
                    right
                    small
                  >
                    {{ iconStatusInActive }}
                  </v-icon>
                </div>
                <v-icon
                  small
                  class="hidden-md-and-up"
                >
                  {{ iconStatusInActive }}
                </v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-row>
        </v-col>
        <v-col
          cols="2"
          sm="1"
          md="2"
        >
          <v-row
            justify="center"
            align="center"
            style="height: 100%;"
            class="hidden-sm-and-down"
          >
            <v-btn
              :disabled="!actionPersmission"
              depressed
              large
              color="secondary"
              @click="onSearchActionButtonClick"
            >
              {{ actionText }}
              <v-icon
                small
                right
              >
                {{ actionIcon }}
              </v-icon>
            </v-btn>
          </v-row>
          <v-row
            justify="end"
            justify-md="center"
            align="center"
            style="height: 100%;"
          >
            <v-btn
              icon
              large
              class="hidden-md-and-up"
            >
              <v-icon>
                fas fa-ellipsis-v
              </v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    statusAllText: {
      type: String,
      default: 'ทั้งหมด',
    },
    statusActiveText: {
      type: String,
      default: 'เปิดใช้งาน',
    },
    statusInActiveText: {
      type: String,
      default: 'ปิดใช้งาน',
    },
    iconStatusAll: {
      type: String,
      default: 'fas fa-asterisk',
    },
    iconStatusActive: {
      type: String,
      default: 'fas fa-check',
    },
    iconStatusInActive: {
      type: String,
      default: 'fas fa-times',
    },
    status: {
      type: String,
      required: true,
    },
    actionText: {
      type: String,
      required: true,
    },
    actionIcon: {
      type: String,
      required: true,
    },
    actionPersmission: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentStatus: '',
      textSearch: '',
    };
  },
  watch: {
    status(value) {
      this.currentStatus = value;
    },
  },
  methods: {
    onSearchActionButtonClick(value) {
      this.$emit('onSearchActionButtonClick', value);
    },
    onStatusChange(value) {
      this.$emit('onStatusChange', value);
    },
    onSearch() {
      this.$emit('search', { status: this.currentStatus, text: this.textSearch });
    },
  },
};
</script>
